<template>
  <div class="clear" />
  <div class="middle">
    <div class="cont">
      <h1 class="pageTitle">News</h1>
      <div class="news clear">
        <table>
          <tr>
            <th>2010/2/9</th>
            <td>ホームページリニューアルしました。</td>
          </tr>
          <tr>
            <th>2010/2/9</th>
            <td>実績：一生聞けるCDリニューアルOPENしました。</td>
          </tr>
          <tr>
            <th>2009/12/20</th>
            <td>
              <a href="/service3" target="_blank"
                >ECサイトパッケージAjax版デモ画面</a
              >をアップしました。
            </td>
          </tr>
        </table>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
